import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio, FormControl, FormControlLabel, Hidden, Paper, Typography } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import messages from 'aurora-translations';
import { ADGMBreadcrumbs, ADGMSnackbar, Loading, ADGMImage } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import FooterButtons from '../FooterButtons';
import styles from './styles';

const ServiceTypeSelection = ({
  classes,
  breadCrumbs,
  radioButtonsData,
  selectedOption,
  handleChange,
  handleNext,
  handleBack,
  loading,
  error,
  footerCancelBtnText,
  footerNextBtnText,
  title,
}) => {
  const isValid = useMemo(() => radioButtonsData?.some(radio => radio?.value === selectedOption), [
    selectedOption,
    radioButtonsData,
  ]);

  return (
    <>
      {loading && <Loading />}
      <Hidden mdDown>
        <ADGMBreadcrumbs paths={breadCrumbs} />
      </Hidden>

      <Paper className={classes.serviceDetail} hasPadding>
        <div className={classes.titleHead}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h6' component='h1' className={classes.title}>
              {keyEmptyCheck(title)}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <ADGMImage name='asterisk.svg' alt='asterisk' className={classes.asteriskIcon} />
            </div>
          </div>
        </div>
        <FormControl component='fieldset' className={classes.radioButtonsFormControl}>
          <RadioGroup row className={classes.radioButtonsContainer}>
            {radioButtonsData?.map(radio => (
              <FormControlLabel
                className={classes.radioButtonControl}
                value={radio?.value}
                onClick={e => handleChange(e.target.value)}
                checked={selectedOption === radio?.value}
                control={<Radio className={classes.radioButton} />}
                label={keyEmptyCheck(radio?.label)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Paper>
      <FooterButtons
        previousBtnText={footerCancelBtnText}
        nextBtnText={footerNextBtnText}
        disableNextBtn={!isValid}
        handleNext={handleNext}
        handleBack={handleBack}
        showNextBtnIcon
        showPreviousBtnIcon
        customClasses={{
          container: classes.buttonsContainer,
          buttonsHolder: classes.buttonsHolder,
        }}
      />
      {error && (
        <ADGMSnackbar message={messages[error?.message]?.id ? keyEmptyCheck(error?.message) : error?.message} />
      )}
    </>
  );
};

ServiceTypeSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
  breadCrumbs: PropTypes.array.isRequired,
  radioButtonsData: PropTypes.array.isRequired,
  selectedOption: PropTypes.any.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  footerNextBtnText: PropTypes.string,
  footerCancelBtnText: PropTypes.string,
  title: PropTypes.string,
};

ServiceTypeSelection.defaultProps = {
  loading: false,
  error: null,
  footerNextBtnText: 'next',
  footerCancelBtnText: 'back',
  title: 'ownership_type',
};

export default withStyles(styles)(ServiceTypeSelection);
